// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "chunks/" + chunkId + "." + {"1061":"27749cd487353d0f1c77","1400":"364afc978a92ca11026e","4656":"36cc07cba68a27e7a83a","5764":"323e748999f6f0c769e0"}[chunkId] + ".css";
};